var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 32.05,
    viewBox: "0 0 40 32.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 32.05)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0A73.155,73.155,0,0,0-24.7,0c-4.7,1-7.6,4-7.6,8V22c0,4,2.9,7,7.7,8a72.888,72.888,0,0,0,12.3,1A74.084,74.084,0,0,0,.1,30c4.6-.9,7.6-4,7.6-8V8C7.7,4,4.7.9,0,0M-5.8,15.9l-10,6a.743.743,0,0,1-.5.1.894.894,0,0,1-.5-.1,1.048,1.048,0,0,1-.5-.9V9a1.05,1.05,0,0,1,.5-.9.908.908,0,0,1,1,0l10,6a1.05,1.05,0,0,1,.5.9,1.19,1.19,0,0,1-.5.9",
    transform: "translate(32.3 -31)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYoutube);
export default __webpack_public_path__ + "static/media/icon-youtube.273b9205.svg";
export { ForwardRef as ReactComponent };